import React from 'react';

export const Unarchive = () => (
  <svg width="14" height="14" viewBox="1.33 1.33 13.34 13.34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M1.3335 3.33333C1.3335 2.70479 1.3335 2.39053 1.52876 2.19526C1.72402 2 2.03829 2 2.66683 2H13.3335C13.962 2 14.2763 2 14.4716 2.19526C14.6668 2.39053 14.6668 2.70479 14.6668 3.33333C14.6668 3.96187 14.6668 4.27614 14.4716 4.47141C14.2763 4.66667 13.962 4.66667 13.3335 4.66667H2.66683C2.03829 4.66667 1.72402 4.66667 1.52876 4.47141C1.3335 4.27614 1.3335 3.96187 1.3335 3.33333Z"
    />
    <path
      fill="currentColor"
      d="M13.3794 5.66629C13.4736 5.66633 13.5702 5.66637 13.6668 5.66504V8.66627C13.6668 11.1804 13.6668 12.4375 12.8858 13.2185C12.1222 13.9821 10.9036 13.9992 8.50016 13.9996V9.30254L9.6285 10.5563C9.81323 10.7615 10.1294 10.7782 10.3346 10.5935C10.5399 10.4087 10.5566 10.0926 10.3718 9.88734L8.37183 7.66514C8.27696 7.55974 8.1419 7.49961 8.00016 7.49961C7.85843 7.49961 7.72336 7.55974 7.6285 7.66514L5.62852 9.88734C5.44379 10.0926 5.46043 10.4087 5.66568 10.5935C5.87094 10.7782 6.18708 10.7615 6.37182 10.5563L7.50016 9.30254V13.9996C5.09673 13.9992 3.87814 13.9821 3.11454 13.2185C2.3335 12.4375 2.3335 11.1804 2.3335 8.66627V5.66504C2.43008 5.66637 2.52682 5.66633 2.62092 5.66629H13.3794Z"
    />
  </svg>
);

export default Unarchive;
